import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import bgImage from "assets/images/ai-background.jpg";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";
import api from "API/api";
import { toast } from "sonner";

const ForgotPassword = () => {
  const initialValues = { email: "" };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  const handleSubmit = async (values) => {
    try {
      let payload = {
        email: values.email,
      };
      const res = await api.post("/forgot-password", payload);
      toast.success(res?.data?.message);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
    }
  };
  
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Forgot Password
          </MDTypography>
        </MDBox>
        <MDBox pt={5} pb={5} px={3}>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {() => (
              <Form>
                <MDBox mb={4}>
                  <MDBox mb={2}>
                    <Field name="email">
                      {({ field }) => (
                        <MDInput
                          {...field}
                          type="text"
                          label="Email"
                          fullWidth
                        />
                      )}
                    </Field>
                    <ErrorMessage
                      name="email"
                      component="div"
                      style={{
                        color: "red",
                        fontSize: "11px",
                        marginLeft: "4px",
                      }}
                    />
                  </MDBox>
                </MDBox>
                <MDBox mt={6} mb={1}>
                  <MDButton
                    type="submit"
                    variant="gradient"
                    color="info"
                    fullWidth
                  >
                    Reset
                  </MDButton>
                </MDBox>
              </Form>
            )}
          </Formik>
        </MDBox>
      </Card>
    </BasicLayout>
  );
};

export default ForgotPassword;
